<template>
  <div id="app">
    <head-Back title="管理中心"></head-Back>
    <div class="pass-user-info">
      <div class="pass-info-div">
        <p>正在开通聊天号</p>
        <p>{{ code }}</p>
      </div>
      <div class="pass-info-pass">
        <div>
          <span>设置新密码</span>
        </div>
        <div>
          <input
            type="password"
            oninput="if(value.length>6)value=value.slice(0,6)"
            v-model="password"
            placeholder="请输入4-6位数字密码"
            @keydown="handleinput2"
          />
        </div>
        <div style="margin-top: 16px;">
          <span>设置新密码</span>
        </div>
        <div>
          <input
            type="password"
            oninput="if(value.length>6)value=value.slice(0,6)"
            v-model="confirmpassword"
            placeholder="请输入4-6位数字密码"
            @keydown="handleinput2"
          />
        </div>
        <div>
          <button name="next" class="next" @click="commitPass">确定</button>
        </div>
      </div>
      <passMsg></passMsg>
    </div>
  </div>
</template>
<script>
import headBack from "../common/head-back";
import passMsg from "../common/passMsg";
import util from "@/utils/util";
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
//接口地址
import api from "../../api/index";
import tips from "@/estoast";

export default {
  metaInfo: {
    title: "管理中心"
  },
  data() {
    return {
      msg: "管理中心",
      code: "",
      password: "",
      confirmpassword: ""
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");

    var token = this.getToken;
    console.log("store里面的toekn有值" + JSON.stringify(token));
    if (token == null || token == "") {
      token = localStorage.getItem("token");
      console.log("localStorage缓存token：" + token);
      store.commit(types.LOGIN, token);
    }
    if (token == "" || token == null) {
      this.$router.push("/login");
    }

    this.code = this.$route.params.code;
    var password = this.$route.params.password;

    console.log("setpass params.code:" + this.$route.params.code);
    console.log("setpass params.pass:" + password);

    if (this.code == "" || this.code == undefined) {
      tips.toast("错误地址");
      this.$router.push("/userCenters");
    }
    if (password == "" || password == undefined) {
      tips.toast("错误地址");
      this.$router.push("/userCenters");
    }
  },
  methods: {
    handleinput2(e) {
      e.target.value = e.target.value.replace(/[^\d]/g, "");
    },
    commitPass: function() {
      if (this.confirmpassword == null || this.confirmpassword == "") {
        tips.toast("请输入密码");
        return false;
      }
      if (password.length != 6) {
        tips.toast("请输入6位数字密码");
        return false;
      }
      if (!util.isNum(this.confirmpassword)) {
        tips.toast("请输入6位数字密码");
        return false;
      }
      if (this.password != this.confirmpassword) {
        tips.toast("两次输入的密码不一致");
        return false;
      }

      var data = {
        code: this.code,
        password: this.password,
        confirmpassword: this.confirmpassword
      };
      this.$axiosHttp({
        method: "POST",
        url: api.qml.setPass,
        data: data
      })
        .then(res => {
          if (res.code == 0) {
            tips.toast("修改成功");
            this.$router.push("/userCenters");
          } else {
            tips.toast(res.message);
          }
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
        });
    }
  },
  components: {
    headBack,
    passMsg
  }
};
</script>
<style  scoped>
.pass-user-info {
  width: 750px;
  height: 1334px;
  background-image: url("../../assets/img/pass-bj@2x.png");
  -moz-background-size: 100% 100%;
  background-size: 100% 100%;
}
.pass-info-div {
  width: 100%;
  height: 120px;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 44px;
  padding: 40px 60px 0px 60px;
  text-align: left;
}

.pass-info-div p {
  height: 24px;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #8f94a0;
  line-height: 24px;
}

.pass-info-dive {
  width: 100%;
  height: 102px;
  font-size: 32px;
  padding: 40px 60px 0px 60px;
}

.pass-info-pass {
  width: 100%;
  height: 488px;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 44px;
  padding: 74px 60px 0px 60px;
  text-align: left;
}

.pass-info-pass span {
  height: 44px;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 44px;
  text-align: left;
}

.pass-info-pass input {
  width: 602px;
  height: 60px;
  background: rgba(19, 19, 37, 1);
  border-radius: 16px;
  margin: 22px 00px 00px 0px;
  border: 1px solid rgba(19, 19, 37, 1);
  color: #ffffff;
  padding: 15px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 60px;
}
.pass-info-pass button {
  width: 632px;
  height: 92px;
  background: linear-gradient(
    90deg,
    rgba(108, 103, 253, 1) 0%,
    rgba(28, 97, 235, 1) 100%
  );
  border-radius: 50px;
  margin: 54px 00px 00px 0px;
  border: 1px transparent solid;
  border: none;
    font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 44px;
}

.pass-info-pass button:active {
  background: rgba(175, 199, 255, 1);
}
</style>


// WEBPACK FOOTER //
// src/components/page/changePassConfirm.vue